import React from 'react';
import cx from 'classnames';

import styles from './CreatePasswordPage.module.scss';

import CreatePasswordBlock, { CreatePasswordBlockProps } from '../../block/CreatePasswordBlock';

export const defaultProps = {
  createPasswordBlock: {
    title: {
      type: 'Title1',
      align: 'Left',
      style: 'Grey1100',
    },
    description: {
      type: 'Body2',
      align: 'Left',
      style: 'Grey700',
    },
    createPassword: {
      state: 'Default',
      type: 'Password',
      label: {
        type: 'Body2',
        align: 'Left',
        style: 'Grey1100',
      },
      textInput: {
        type: 'Password',
        style: 'Default',
        text: {
          type: 'Body2',
          align: 'Left',
          style: 'Grey700',
        },
        icon: {
          asset: 'Show',
          style: 'Grey1100',
        },
      },
    },
    confirmPassword: {
      state: 'Default',
      type: 'Password',
      label: {
        type: 'Body2',
        align: 'Left',
        style: 'Grey1100',
      },
      textInput: {
        type: 'Password',
        style: 'Default',
        text: {
          type: 'Body2',
          align: 'Left',
          style: 'Grey700',
        },
        icon: {
          asset: 'Show',
          style: 'Grey1100',
        },
      },
    },
    button: {
      size: 'Medium',
      type: 'Text',
      style: 'BrandSquare',
      text: {
        type: 'Button1',
        align: 'Center',
        style: 'Grey1100',
      },
    },
  } as CreatePasswordBlockProps,
};

export type CreatePasswordPageProps = {
  createPasswordBlock?: CreatePasswordBlockProps;
  className?: string;
};

const CreatePasswordPage: React.FC<CreatePasswordPageProps> = ({
  createPasswordBlock,
  className,
}) => {
  return (
    <div className={cx(styles.createPasswordPage, className)}>
      <CreatePasswordBlock
        className={styles.createPasswordBlock}
        {...createPasswordBlock} />
    </div>
  );
};

CreatePasswordPage.defaultProps = defaultProps;

export default CreatePasswordPage;
